import { ApiError } from "@/lib/api";

export interface ActionErrorCopy {
  message: string;
  /** Offer a reload: the row on screen is out of date. */
  reload: boolean;
}

const MISSING_RECORD: ActionErrorCopy = {
  message: "This record has changed or is missing. Reload, and tell IT if it keeps happening.",
  reload: true,
};

/**
 * A refused dashboard action in plain language. The server's own messages
 * name raw stages and field names, so they are never shown; the code decides.
 */
export function describeActionError(error: unknown, subject: "employee" | "order" = "employee"): ActionErrorCopy {
  const code = error instanceof ApiError ? error.code : null;
  switch (code) {
    case "CONFLICT_RELOAD":
      return {
        message:
          subject === "order"
            ? "Someone else changed this replacement order — reload"
            : "Someone else changed this employee — reload",
        reload: true,
      };
    case "PHOTO_MISSING":
      return { message: "No photo on file. Record the photo before marking the badge made.", reload: false };
    case "INVALID_TRANSITION":
      return {
        message: "That change is not allowed from this employee's current stage. Reload to see where they are now.",
        reload: true,
      };
    case "VALIDATION_ERROR":
      return { message: "Something you entered was not accepted. Check it and try again.", reload: false };
    case "NOT_FOUND":
    case "NOT_IN_ORDER":
    case "NOT_A_REPLACEMENT":
      return MISSING_RECORD;
    default:
      return { message: "Something went wrong. Try again.", reload: false };
  }
}
